var _path, _rect, _circle, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadytolockicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5324 5.61044C10.803 4.18205 10.1941 1.2949 6.74338 1.00951C5.74351 0.926812 3.57235 1.34781 2.88672 3.69339V7.61771",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 8.32227,
    width: 11.6713,
    height: 7.9274,
    rx: 1.25,
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.47292,
    cy: 11.7903,
    r: 0.75,
    stroke: "#2E77D0",
    strokeWidth: 0.529823
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.28136,
    y: 12.9064,
    width: 0.293197,
    height: 2.09748,
    stroke: "#2E77D0",
    strokeWidth: 0.293197
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadytolockicon);
export default __webpack_public_path__ + "static/media/readytolockicon.89c9abe11e005774fd0c624a9bc627b1.svg";
export { ForwardRef as ReactComponent };